import { createContext } from "react";

export interface AuthContextType {
    isAuthenticated: boolean;
    user: any;
    token: string | null;
    roles: any[];
    organizations: any[];
    selectedOrganization: any | null;
    setIsAuthenticated: (value: boolean) => void;
    setUser: (value: any) => void;
    setToken: (value: string) => void;
    setRoles: (value: any[]) => void;
    setOrganizations: (value: any[]) => void;
    setSelectedOrganization: (value: any | null) => void;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
